export const getNoiseSuppressionFallback = () => {
  if (typeof navigator === "undefined") {
    return null;
  }

  const userAgent = navigator.userAgent || "";
  const platform = navigator.platform || "";
  const source = `${userAgent} ${platform}`.toLowerCase();

  if (source.includes("mac")) {
    return {
      title: "Как выключить шумоподавление на macOS",
      steps: [
        "Открой `Системные настройки` -> `Звук` -> `Вход` и выбери нужный микрофон.",
        "Если во время звонка доступен `Пункт управления` -> `Микрофон`, выбери `Широкий спектр`, а не `Изоляция голоса`.",
        "Если используешь AirPods, USB-микрофон или аудиоинтерфейс, проверь приложение производителя и отключи там `Noise reduction`, `Voice isolation` или похожие улучшатели.",
      ],
    };
  }

  if (source.includes("iphone") || source.includes("ipad") || source.includes("ios")) {
    return {
      title: "Как выключить шумоподавление на iPhone или iPad",
      steps: [
        "Во время звонка открой `Пункт управления`.",
        "Нажми `Режим микрофона` и выбери `Стандартный` или `Широкий спектр`, если он доступен.",
        "Если используешь гарнитуру, проверь ее настройки и отключи там шумоподавление микрофона.",
      ],
    };
  }

  if (source.includes("android")) {
    return {
      title: "Как выключить шумоподавление на Android",
      steps: [
        "Открой настройки телефона и найди разделы `Звук`, `Запись`, `Спец. возможности` или параметры вызовов.",
        "Отключи параметры вроде `Шумоподавление`, `Voice Focus`, `Clear voice`, `Noise reduction` или `Улучшение речи`.",
        "Если используешь Bluetooth-гарнитуру, проверь приложение производителя и выключи обработку микрофона там.",
      ],
    };
  }

  if (source.includes("win")) {
    return {
      title: "Как выключить шумоподавление в Windows",
      steps: [
        "Открой `Параметры` -> `Система` -> `Звук` -> `Ввод` и выбери активный микрофон.",
        "Отключи эффекты вроде `Noise suppression`, `Voice focus`, `Audio enhancements` или `Улучшение звука`, если они включены.",
        "Если микрофон идет через Realtek, NVIDIA Broadcast, Logitech, SteelSeries или другое ПО производителя, выключи обработку микрофона в этом приложении.",
      ],
    };
  }

  return {
    title: "Как выключить шумоподавление на устройстве",
    steps: [
      "Проверь системные настройки звука и параметры выбранного микрофона.",
      "Если используешь гарнитуру или аудиоинтерфейс, открой приложение производителя устройства.",
      "Выключи параметры `Noise suppression`, `Voice isolation`, `Clear voice`, `Noise reduction` или `Audio enhancements`.",
    ],
  };
};
